// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__30aFL","label":"Category_label__3ZS7O","content":"Category_content__3kuY4","header":"Category_header__3Zp5w","location":"Category_location__S22A0"};